import * as React from "react";
import { FileText, ShieldCheck, Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const candidates = [{
  id: 1,
  firstName: "Alessio",
  lastName: "COLINI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/cv_albanolaziale_ColiniAlessio_page_0001d9e1.pdf",
  casellarioUrl: "#"
}, {
  id: 2,
  firstName: "Enrica",
  lastName: "CAMMARANO",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/CAMMARANO-ENRICA-CV.pdf",
  casellarioUrl: "#"
}, {
  id: 3,
  firstName: "Gianna",
  lastName: "CELLETTI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-GIanna-Celletti.pdf",
  casellarioUrl: "#"
}, {
  id: 4,
  firstName: "Luca detto Galante",
  lastName: "GALANTI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-LUCA-GALANTI.pdf",
  casellarioUrl: "#"
}, {
  id: 5,
  firstName: "Chiara",
  lastName: "MENGARELLI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/MENGARELLI-CHIARA.pdf",
  casellarioUrl: "#"
}, {
  id: 6,
  firstName: "Aldo",
  lastName: "OROCCINI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/CV_Aldo_Oroccini_page_0001d9e1.pdf",
  casellarioUrl: "#"
}, {
  id: 7,
  firstName: "Silvia",
  lastName: "BORELLI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/borelli-2-1.pdf",
  casellarioUrl: "#"
}, {
  id: 8,
  firstName: "David",
  lastName: "DERNA",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-David-Derna.pdf",
  casellarioUrl: "#"
}, {
  id: 9,
  firstName: "Beatrice",
  lastName: "FIORI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/CV_Beatrice-Fiori.pdf",
  casellarioUrl: "#"
}, {
  id: 10,
  firstName: "Roberto",
  lastName: "FABRIZI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/FABRIZI-ROBERTO-CV-AGG.2025.pdf",
  casellarioUrl: "#"
}, {
  id: 11,
  firstName: "Simonetta",
  lastName: "FARROTTI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-SIMONETTA-FARROTTI.pdf",
  casellarioUrl: "#"
}, {
  id: 12,
  firstName: "Filomena",
  lastName: "FIORITO",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/GIORGI-REMO.C.VITAE_.2026.pdf",
  casellarioUrl: "#"
}, {
  id: 13,
  firstName: "Remo",
  lastName: "GIORGI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/LANDI-LUCA.pdf",
  casellarioUrl: "#"
}, {
  id: 14,
  firstName: "Angelo",
  lastName: "GIUSTINI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/CV-FABRIZIO-LITARDI_2026.pdf",
  casellarioUrl: "#"
}, {
  id: 15,
  firstName: "Luca",
  lastName: "LANDI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/LUONGO-MARTA-CV.pdf",
  casellarioUrl: "#"
}, {
  id: 16,
  firstName: "Fabrizio",
  lastName: "LITARDI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/Curriculum-vitae-Antonio-Micheli.pdf",
  casellarioUrl: "#"
}, {
  id: 17,
  firstName: "Marta",
  lastName: "LUONGO",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/MARCIANO-MASSIMO.pdf",
  casellarioUrl: "#"
}, {
  id: 18,
  firstName: "Antonio",
  lastName: "MICHELI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/ZEGA-MASSIMO-CV.pdf",
  casellarioUrl: "#"
}, {
  id: 19,
  firstName: "Massimo",
  lastName: "MARCIANO",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/FORTINI-TIZIANO.pdf",
  casellarioUrl: "#"
}, {
  id: 20,
  firstName: "Eleonora",
  lastName: "VINCI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/SANTI-MARIA-TERESA.pdf",
  casellarioUrl: "#"
}, {
  id: 21,
  firstName: "Massimo",
  lastName: "ZEGA",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/Eleonora-Vinci-CV-EUROPASS.pdf",
  casellarioUrl: "#"
}, {
  id: 22,
  firstName: "Tiziano",
  lastName: "FORTINI",
  cvUrl: "https://borellisindaco.it/wp-content/uploads/2026/05/1.Curriculum-Vitae-_-Sandra-Morico.pdf",
  casellarioUrl: "#"
}, {
  id: 23,
  firstName: "Maria Teresa",
  lastName: "SANTI",
  cvUrl: "#",
  casellarioUrl: "#"
}, {
  id: 24,
  firstName: "Sandra",
  lastName: "MORICO",
  cvUrl: "#",
  casellarioUrl: "#"
}];
export default function CandidatiLista2() {
  return <section id="candidati-lista-2" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">Candidati Lista Partito Democratico</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto mb-6">
            Elenco ufficiale dei candidati. Consulta i curriculum vitae e i certificati del casellario giudiziale per ogni candidato, nel rispetto della normativa sulla trasparenza.
          </p>
          <div className="flex justify-center">
            <Button variant="ghost" size="sm" asChild className="text-primary hover:text-primary/80 hover:bg-primary/10">
              <Link to="https://borellisindaco.it/wp-content/uploads/2026/05/CASELLARI-PD.pdf" newTab>
                <Download className="w-4 h-4 mr-2" />
                Scarica Casellari Giudiziali
              </Link>
            </Button>
          </div>
        </div>

        <div className="border border-border rounded-lg overflow-hidden bg-card shadow-sm">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow className="hover:bg-transparent">
                <TableHead className="w-[40%] md:w-[50%] font-semibold text-foreground font-default">
                  Candidato
                </TableHead>
                <TableHead className="text-center font-semibold text-foreground font-default">
                  Curriculum Vitae
                </TableHead>
                <TableHead className="text-center font-semibold text-foreground font-default">
                  Casellario Giudiziale
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {candidates.map((candidate, i) => <TableRow key={candidate.id} data-index={i} className="even:bg-muted/20 transition-colors">
                  <TableCell className="font-medium text-foreground py-4">
                    {candidate.lastName} {candidate.firstName}
                  </TableCell>
                  <TableCell className="text-center py-4">
                    <Button variant="ghost" size="sm" asChild className="text-primary hover:text-primary/80 hover:bg-primary/10">
                      <Link to={candidate.cvUrl} newTab>
                        <FileText className="w-4 h-4 md:mr-2" />
                        <span className="hidden md:inline">Scarica CV</span>
                        <span className="md:hidden sr-only">Scarica CV</span>
                      </Link>
                    </Button>
                  </TableCell>
                  <TableCell className="text-center py-4">
                    <Button variant="ghost" size="sm" asChild className="text-primary hover:text-primary/80 hover:bg-primary/10">
                      <Link to={candidate.casellarioUrl} newTab>
                        <ShieldCheck className="w-4 h-4 md:mr-2" />
                        <span className="hidden md:inline">Scarica Certificato</span>
                        <span className="md:hidden sr-only">Scarica Certificato</span>
                      </Link>
                    </Button>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}